import { ReactTFC } from "../../utils/fp/missing-ts-parts";

import { css } from "@emotion/react";

import { CSS_MQ } from "../../styles/breakpoints";
import { AspectRatio } from "../_shared-components/image-related/AspectRatio";
import React from "react";
import { ComponentAccordionType } from "@swo/storefront";
import { ContentfulImage } from "../_shared-components/image-related/ContentfulImage";

import cn from "classnames";

export const AccordionImage: ReactTFC<{
  image: NonNullable<ComponentAccordionType["image"]>;
  width: ComponentAccordionType["width"];
}> = props => {
  const imageAlignmentClassName = props.image.alignImage === "Right" ? "align-right" : "align-left";
  const imageShapeClassName = props.image.imageShape === "Oval" ? "shape-oval" : "shape-rectangular";

  return (
    <div
      className={cn(imageAlignmentClassName, imageShapeClassName)}
      css={css`
        .narrow > & {
          width: 100%;

          ${CSS_MQ.atMostSm} {
            margin-bottom: 40px;
          }

          ${CSS_MQ.atLeastSm} {
            width: 50%;

            &.align-left {
              margin-right: 30px;
            }

            &.align-right {
              margin-left: 30px;
              order: 2;
            }
          }

          ${CSS_MQ.atLeastMd} {
            &.align-left {
              margin-right: 56px;
            }

            &.align-right {
              margin-left: 56px;
            }
          }
        }

        .wide > & {
          width: 50%;
          margin-bottom: 40px;

          &.align-right {
            margin-left: auto;
          }
        }
      `}
    >
      {props.image.imageShape === "Oval" || props.width === "Narrow" ? (
        <AspectRatio height={1} width={1}>
          <ContentfulImage
            assetId={props.image.sys.id}
            contentfulLink={{
              url: props.image.url,
              requestedWidth: 700,
              noTransparentBackground: true,
            }}
            lazyLoaded={"lazy"}
            alt={props.image.description || props.image.title}
            css={css`
              width: 100%;
              height: 100%;
              object-fit: cover;

              .shape-oval & {
                border-radius: 50%;
              }
            `}
          />
        </AspectRatio>
      ) : (
        <ContentfulImage
          assetId={props.image.sys.id}
          contentfulLink={{
            url: props.image.url,
            noTransparentBackground: true,
            requestedWidth: 700,
          }}
          lazyLoaded={"lazy"}
          alt={props.image.description || props.image.title}
          css={css`
            object-fit: cover;
            object-position: center;
            width: 100%;
          `}
          attachPictureStyles={css`
            display: flex;
            max-height: 500px;
            max-width: 100%;
            overflow: hidden;
          `}
        />
      )}
    </div>
  );
};
